import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import OralTreatmentUnit from './OralTreatmentUnit';
// utils
import { stockSolutionToSystem } from 'utils';

const OralTreatmentLabel = ({ quantity, gallonsValue, product, measurementSystem }) => {
  const isMetric = measurementSystem === 'metric';
  const stockSolution = isMetric ? stockSolutionToSystem(gallonsValue, 'metric') : parseInt(gallonsValue, 10);

  return (
    <span>
      <span>{product.name} • </span>
      {product.dosage_measure !== 'head'
        ? <span>{quantity} {quantity < 1 ? 'of' : 'x'} <OralTreatmentUnit product={product} /></span>
        : <span>{quantity} <FormattedMessage id="container.checkupEdit.reportMedications.oralLabel" /></span>}
      {gallonsValue && ` / ${stockSolution} `}
      {gallonsValue && <FormattedMessage id={isMetric ? 'general.short.liters' : 'general.short.gal'} />}
    </span>
  );
};

OralTreatmentLabel.propTypes = {
  product: T.object.isRequired,
  quantity: T.oneOfType([T.string, T.number]),
  gallonsValue: T.oneOfType([T.string, T.number]),
  measurementSystem: T.string,
};

export default OralTreatmentLabel;
